import React, { useEffect } from 'react'
import './Services.css';
import { MdQueuePlayNext, MdMemory, MdFingerprint, MdCloudDone, MdCloudQueue, MdSettingsBackupRestore, MdCode } from "react-icons/md";
import Aos from 'aos';
import 'aos/dist/aos.css';
const Services = () => {

    useEffect(() => {
        Aos.init({ duration: 3000 });
    }, [])

    return (
        <div className='services' id='services' data-aos='fade-up'>
            <div className='services__title'>Explore what we offer</div>
            <div className='services__titleBorder'></div>
            <div className='services__content'>

                <div className='services__card'>
                    <span><MdQueuePlayNext /></span>
                    <div className='serices__cardTitle'>Technical Assistance</div>
                    <div className='services__cardDescription'>
                        It is important to have a true IT consulting partner that focuses on your best interests. monitor and maintain computer systems across your organisation.
                        </div>
                </div>

                <div className='services__card'>
                    <span>< MdMemory /></span>
                    <div className='serices__cardTitle'>Hardware Upgrade</div>
                    <div className='services__cardDescription'>
                        Upgrading your device rather than replacing it, with minor upgrades that gives a massive performance improvements.
                        </div>
                </div>

                <div className='services__card'>
                    <span><MdCloudDone /></span>
                    <div className='serices__cardTitle'>Cloud Services</div>
                    <div className='services__cardDescription'>
                        Support for all major cloud solutions, including IaaS, PaaS, SaaS and Storage.
                        Reduce your maintenance cost and gain flexibility with cloud solutions.
                        </div>
                </div>

                <div className='services__card'>
                    <span><MdFingerprint /></span>
                    <div className='serices__cardTitle'>Threats Protection</div>
                    <div className='services__cardDescription'>
                        Defend against sophisticated malware and Protect your  devices and data from various threats and effectively protects your business from cyber attacks.
                        </div>
                </div>

                <div className='services__card'>
                    <span><MdSettingsBackupRestore /></span>
                    <div className='serices__cardTitle'>Backup & Recovery</div>
                    <div className='services__cardDescription'>
                        Keep your business data protected in modern methods, Protect your business from data loss event, even if your hardware has been destroyed.
                        </div>
                </div>

                <div className='services__card'>
                    <span><MdCode /></span>
                    <div className='serices__cardTitle'>Web Development</div>
                    <div className='services__cardDescription'>
                        Build Modern web applications which are fast, reliable, safe, offering all the latest and greatest features and user-friendly focusing on both UI and UX.
                        </div>
                </div>
            </div>
        </div>
    )
}

export default Services
